<template>
  <footer class="footer">
    <div class="wrapper">
      <div class="column">
        <router-link to="/" class="logo">
          <img src="./../assets/img/logo.svg" class="img">
        </router-link>
        <div class="list">
          <a v-for="link in socials" :key="link.image" :href="link.link" target="_blank" class="item">
            <img :src="link.img" class="img" />
          </a>
        </div>
      </div>
      <div class="column">
        <ul class="nav">
          <li class="nav__item">
            <router-link class="desc" to="/">
              <b>{{ $t('Home') }}</b>
            </router-link>
          </li>
          <li class="nav__item">
            <router-link class="desc" to="/products/all">
              <b>{{ $t('Store') }}</b>
            </router-link>
          </li>
          <li class="nav__item">
            <router-link class="desc" to="/support">
              <b>{{ $t('Support') }}</b>
            </router-link>
          </li>
        </ul>
      </div>
      <div v-if="textPageList && textPageList.length" class="column">
        <ul class="nav">
          <li v-for="item in textPageList" :key="item.id" class="nav__item desc">
            <a v-if="item" @click="goToPage(item.id)">
              <b v-if="item.title">{{ $t(item.title) }}</b>
            </a>
          </li>
        </ul>
      </div>
      <div class="column">
        <div class="desc">
          <b>{{ $t('Support:') }}</b>
        </div>
        <div class="desc">
          {{ footerSupportEmail }}
        </div>
        <div class="desc requisites">
          {{ footerRequisites }}
        </div>
        <div class="desc requisites">
          {{ footerCopyright }}
        </div>
      </div>
    </div>

    <div class="wrapper payment-methods" v-if="paymentMethodsList && paymentMethodsList.length">
      <ul class="payment-methods-list">
        <li v-for="image in allImages" :key="image" class="image-wrapper">
          <img :src="image" class="support-icon img" />
        </li>
      </ul>
    </div>
  </footer>
</template>


<script>

export default {
  name: 'FooterComponent',
  components: {

  },
  props: {
    textPageList: {
      type: Array,
      required: true
    },
    footerRequisites: {
      type: String,
      required: true
    },
    footerCopyright: {
      type: String,
      required: true
    },
    footerSupportEmail: {
      type: String,
      required: true
    },
    paymentMethods: {
      type: [Object, Array],
    }
  },
  data: function () {
    return {
      socials: [],
    }
  },
  computed: {
    paymentMethodsList() {
      if (!this.paymentMethods) return [];
      return this.paymentMethods;
    },
    allImages() {
      return this.paymentMethodsList.flatMap(this.getImages);
    }

  },
  watch: {

  },
  mounted() {
    this.getSocials();
  },
  methods: {
    getImages(method) {
      const images = [];
      if (method.code === 'card' || method.title === 'Visa/Mastercard') {
        images.push(require('@/assets/img/methods/visa.svg'), require('@/assets/img/methods/mc_symbol.svg'));
        images.push(require('@/assets/img/methods/3ds.png'));
      } else if (method.code === 'eps' || method.title === 'EPS') {
        images.push(require('@/assets/img/methods/eps.svg'));
      } else if (method.code === 'trustly' || method.title === 'Trustly') {
        images.push(require('@/assets/img/methods/trustly.svg'));
      } else if (method.code === 'giropay' || method.title === 'GiroPay') {
        images.push(require('@/assets/img/methods/giropay.svg'));
      } else if (method.code === 'blik' || method.title === 'Blik') {
        images.push(require('@/assets/img/methods/blik.svg'));
      } else if (method.code === 'paidby' || method.title === 'Paidby') {
        images.push(require('@/assets/img/methods/paidby.svg'));
      } else if (method.code === 'klarna' || method.title === 'Klarna') {
        images.push(require('@/assets/img/methods/klarna.svg'));
      } else if (method.code === 'sofortuberweisung' || method.title === 'Sofortuberweisung') {
        images.push(require('@/assets/img/methods/sofortuber.svg'));
      } else if (method.code === 'ideal' || method.title === 'iDEAL') {
        images.push(require('@/assets/img/methods/ideal.svg'));
      } else if (method.code === 'bancontact' || method.title === 'Bancontact') {
        images.push(require('@/assets/img/methods/bancontact.svg'));
      } else if (method.code === 'mybank' || method.title === 'MyBank') {
        images.push(require('@/assets/img/methods/mybank.png'));
      } else if (method.code === 'google_pay' || method.title === 'Google Pay') {
        images.push(require('@/assets/img/methods/google_pay.png'));
      } else if (method.code === 'apple_pay' || method.title === 'Apple Pay') {
        images.push(require('@/assets/img/methods/apple_pay.svg'));
      }
      return images;
    },
    goToPage(id) {
      this.$emit('goToPage', id)
    },
    getSocials() {
      this.$http.get('social-links')
        .then((res) => {
          this.socials = res.data.payload;
        })
        .catch(() => {
        });
    },
  }
}
</script>
<style scoped lang="scss">
.footer {
  padding: 64px 16px;
  background: #11131C;
}

.footer .wrapper {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 32px;
}

.footer .wrapper .column {
  flex: 1;
}

.footer .wrapper .column .list {
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.footer .wrapper .column .list .img {
  width: 24px;
}

.footer .wrapper .column .desc {
  white-space: pre-line;

  :not(:first-child) {
    margin-top: 16px;
  }
}

.footer .wrapper .column .desc.requisites {
  margin-top: 16px;
}


.footer .wrapper .column .nav__item+.nav__item {
  margin-top: 16px;
}

.footer .wrapper.payment-methods {
  margin-top: 20px;
  justify-content: flex-start;
}

.footer .payment-methods-list {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 10px;
}

.footer .payment-methods-list img {
  max-width: 70px;
  max-height: 35px;
  display: inline-block;
  width: 100%;
}
</style>